module.exports = __webpack_public_path__ + "static/img/draw_text.e6a3d8c7.png";